import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';
import { I18n } from 'react-redux-i18n';

let initialized = false;

function initAlertifyTheme() {
    if (initialized) {
        return;
    }
    initialized = true;

    alertify.defaults.transition = 'fade';
    alertify.defaults.movable = false;
    alertify.defaults.closable = true;
    alertify.defaults.closableByDimmer = true;
    alertify.defaults.maximizable = false;
    alertify.defaults.pinnable = false;
    alertify.defaults.glossary = {
        title: I18n.t('warning'),
        ok: I18n.t('delete'),
        cancel: I18n.t('cancel'),
    };
}

function applyDialogClasses(dialog, variant) {
    const root = dialog?.elements?.root;
    if (!root) {
        return;
    }
    root.classList.add('ebi-alertify');
    root.classList.remove('ebi-alertify--danger', 'ebi-alertify--default');
    root.classList.add(variant === 'danger' ? 'ebi-alertify--danger' : 'ebi-alertify--default');
}

/**
 * @param {object} options
 * @param {string} [options.title]
 * @param {string} options.message
 * @param {() => void} options.onConfirm
 * @param {() => void} [options.onCancel]
 * @param {string} [options.okLabel]
 * @param {string} [options.cancelLabel]
 * @param {'danger'|'default'} [options.variant]
 */
export function confirmDialog({
    title,
    message,
    onConfirm,
    onCancel,
    okLabel,
    cancelLabel,
    variant = 'default',
}) {
    initAlertifyTheme();

    const dialog = alertify.confirm(
        title || I18n.t('warning'),
        message,
        () => {
            if (typeof onConfirm === 'function') {
                onConfirm();
            }
        },
        () => {
            if (typeof onCancel === 'function') {
                onCancel();
            }
        },
    );

    dialog.set({
        labels: {
            ok: okLabel || I18n.t('delete'),
            cancel: cancelLabel || I18n.t('cancel'),
        },
        onshow() {
            applyDialogClasses(this, variant);
        },
    });

    // Apply immediately: alertify may already be visible before onshow is wired.
    applyDialogClasses(dialog, variant);

    return dialog;
}

export function confirmDelete(message, onConfirm, onCancel) {
    return confirmDialog({
        title: I18n.t('delete_confirm_title'),
        message: message || I18n.t('delete_confirm_message'),
        onConfirm,
        onCancel,
        okLabel: I18n.t('delete'),
        cancelLabel: I18n.t('cancel'),
        variant: 'danger',
    });
}

export default confirmDialog;
